
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { HomeIcon, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const isProfilePath = location.pathname.startsWith("/profile/");

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-8 bg-white rounded-lg shadow-md max-w-md">
        <h1 className="text-4xl font-bold text-primary-700 mb-4">404</h1>
        
        {isProfilePath ? (
          <>
            <p className="text-xl text-gray-700 mb-2">Profile Not Found</p>
            <p className="text-gray-600 mb-6">The athlete profile you're looking for doesn't exist or may have been moved.</p>
          </>
        ) : (
          <p className="text-xl text-gray-600 mb-6">Oops! Page not found</p>
        )}

        <div className="space-y-3">
          <Button asChild className="w-full bg-primary-700 hover:bg-primary-800">
            <Link to="/">
              <HomeIcon className="mr-2 h-4 w-4" />
              Return to Home
            </Link>
          </Button>
          
          <Button 
            variant="outline" 
            onClick={() => window.history.back()}
            className="w-full"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
